import { INotesSubscriber } from '../models/conversation-interfaces';

export abstract class NotificationsServiceInterface {

    public abstract getSubscriptions(subscriberId: number, isPublic: boolean): Promise<INotesSubscriber[]>;
    public abstract markAllAsSeen(subscriberId: number): Promise<number>;
    public abstract markAsSeen(listId: number, subscriberId: number): Promise<number>;
}
